import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";

import { IntlFormatUSD } from "../../../../../utils";
import { CENTS_IN_DOLLAR } from "../../../../../constants";
import { getSumAndCountSales, getSumAndCountPurchasesToTookEvaluation } from "../utils";

const PassersReport: React.FC = () => {
  const { passersStats } = useSelector((state) => state.financials);

  const { sumTotalAmount, sumUnitsSold, averageUnitPrice } = getSumAndCountSales(
    passersStats.data.sumBillingHistory
  );
  const spentToPassEvaluation = getSumAndCountPurchasesToTookEvaluation(
    passersStats.spentToPassEvaluation.data
  );

  const currentDate = moment().format("MMM DD, YYYY");

  const numberOfPassers = passersStats.data.sumBillingHistory.length;
  const { free_reset_count, paid_reset_count, total_price, rebil_count } = spentToPassEvaluation;
  const avg_resets_count = (paid_reset_count + free_reset_count) / numberOfPassers;

  const isLoading = passersStats.loading || passersStats.spentToPassEvaluation.loading;
  if (!numberOfPassers || isLoading) return null;

  return (
    <div>
      <h3>
        Passer Report from <u>{currentDate}</u>
      </h3>
      <p>
        The number of passers on {currentDate} is <u>{numberOfPassers}</u>. The total sales value of
        these {numberOfPassers} traders equals{" "}
        <u>{IntlFormatUSD(sumTotalAmount / CENTS_IN_DOLLAR)}</u>, with the total number of units
        sold at <u>{sumUnitsSold}</u>. The average unit price for their sales is{" "}
        <u>{IntlFormatUSD(averageUnitPrice / CENTS_IN_DOLLAR)}</u>.
      </p>
      <p>
        The total spending on the evaluations passed in this report is{" "}
        <u>{IntlFormatUSD(total_price / CENTS_IN_DOLLAR)}</u>. The traders passed the evaluation
        using <u>{rebil_count}</u> rebills, <u>{paid_reset_count}</u> resets and{" "}
        <u>{free_reset_count}</u> free resets. The average number of resets used to pass the
        evaluation is <u>{avg_resets_count.toFixed(2)}</u>.
      </p>
    </div>
  );
};

export default PassersReport;
